{
  "name": "CloudServer",
  "tagline": "Облачные серверы, сети и хранилища в одной панели"
}
